export interface DocumentMetadata {
  title?: string;
  doc_number?: string;
  revision?: string;
  date?: string;
  subtitle?: string;
}

export interface NiiReportContentResponse {
  documentMetadata?: DocumentMetadata;
  data?: RecordsType[];
  total?: number;
  page?: number;
  limit?: number;
  totalPages?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filtersData?: Record<string, any>;
}

export enum NiiReportTab {
  NIR = 'nir',
  KNOWN = 'known',
  CORRECTED = 'corrected'
}
export enum NiiNirImpactType {
  SOFTWARE_ONLY = 'Software Only',
  SOFTWARE_AND_HARDWARE = 'Software and Hardware',
  GENERAL_CORRECTION = 'General Correction'
}
export interface NiiReportContentQuery {
  page?: number;
  limit?: number;
  tab?: NiiReportTab;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  technology?: string;
  impactType?: NiiNirImpactType;
  impactAtUpgrade?: string;
  fromRelease?: string;
  toRelease?: string;
  trIssuedFor?: string;
  faultType?: string;
  solutionDeliveredIn?: string;
  filterList?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export enum ReportsType {
  PLAYBOOK = 'playbook',
  TROUBLE = 'trouble',
  KNOWN_LIMITATIONS = 'know_limitations',
  CORRECTED_LIMITATIONS = 'corrected_limitations'
}

export interface RecordsType {
  section_number?: string;
  release?: string;
  technology?: string; // "NR" | "LTE"
  feature_name?: string;
  enhancement_and_benefit?: string;
  faj_number?: string;
  cxc?: string;
  value_package?: string;
  vp_faj?: string;
  ran_compute_group?: string;
  feature_licensing?: string;
  impact_at_upgrade?: string;
  impact_type?: string; // "Software Only" | "Software and Hardware"
  cm_impact?: string[];
  new_alarms?: string[];
  kpi_deviations?: string[];
  internal_ericsson_reference?: string;
  short_description?: string;
  metadata?: RecordsMetadata[];
  subsections?: RecordsSubsection;
  additional_information?: RecordsAdditionalInformation;

  //NIR Corrected limitations
  tr_id?: string;
  correction_title?: string;
  description_of_correction?: string;
  format_type?: string; // "FULL" | "SIMPLE"
  has_ktl?: string; // 'Yes' | 'No' | ''
  has_tco?: string; // 'Yes' | 'No' | ''

  //KLL Known limitations
  tr_issued_for?: string;
  description?: string;
  observation_summary?: string[];
  solution_summary?: string[];
  impact_hw?: ImpactHW;
  sw_feature_faj?: string[];
  mhweb_observation?: string;
  mhweb_answer?: string;
  workaround?: string;
  impacted_area?: string;
  solution_area?: string;
  product?: string;
  fault_type?: string;
  duplicate_tr?: string;
  comments?: string;

  //KLL Corrected Limitations
  solution_delivered_in?: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ReportsMetadata {
  title?: string;
  doc_number?: string;
  revision?: string;
  date?: string;
  subtitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface RecordsMetadata {
  feature_name?: string;
  feature_identity?: string;
  value_package_name?: string;
  value_package_identity?: string;
  node_type?: string;
  access_type?: string;
  impact_at_upgrade?: string;
  licensing?: string;
}

export interface RecordsSubsection {
  description_of_correction?: string;
  summary_and_benefits?: string;
  capacity_and_performance?: string;
  operation?: string;
  interfaces?: string;
  hardware?: string;
  other_network_elements?: string;
  backward_compatible_changes?: string;
}

export interface RecordsAdditionalInformation {
  metadata?: AdditionalInfoMetadata[];
  known_temporary_limitations?: string;
  temporary_configuration_options?: string;
}

export interface AdditionalInfoMetadata {
  internal_ericsson_reference?: string;
  mtr_release?: string;
  f_state?: string;
}

export interface ImpactHW {
  product_names: string[];
  product_numbers: string[];
  ran_compute_group: string[];
  radio_group: string[];
  radio_capabilities: string[];
}

export interface ReportFiltersType {
  attribute: string;
  name: string;
  title: string;
  label: string;
  type: string;
}
